<template>
    <div id="app">
        <router-view />
		<a
            href="http://www.beian.miit.gov.cn"
            target="_blank"
            rel="nofollow"
            class="out_link"
            style="display:block;text-align:center;font-size:12px;color:#3e474e;width: 100%;bottom: 0;"
        >粤ICP备15115530号-2</a>
    </div>
</template>
<script>
import { cache } from './utils/cache'

export default {
    components: {},
    created() {
        this.storeGetAndSave()
    },
    methods: {
        storeGetAndSave() {
            const data = cache.session('store')
            if (data) {
                this.$store.replaceState(
                    Object.assign({}, this.$store.state, data)
                )
            }
            const isIOS =
                    navigator.userAgent.match(/iPad/i) ||
                    navigator.userAgent.match(/iPhone/i),
                eventName = isIOS ? 'pagehide' : 'beforeunload'
            window.addEventListener(eventName, () => {
                cache.session('store', this.$store.state)
            })
        }
    }
}
</script>
<style lang="stylus">
body
    font-size: 16px !important
    background-color: #f3f3f3
#app
    // font-family: 'Avenir', Helvetica, Arial, sans-serif
    // -webkit-font-smoothing: antialiased
    // -moz-osx-font-smoothing: grayscale
    // text-align: center
    // color: #2c3e50
    padding-bottom: 55px
#nav
    padding: 30px
    a
        font-weight: bold
        color: #2c3e50
        &.router-link-exact-active
            color: #42b983
</style>
